import { workspaceService } from "@/services/workspaceService";

export default {
  namespaced: true,

  state: {
    currentTenantId: null,
    currentTenantName: null,
    availableWorkspaces: [],
  },

  mutations: {
    SET_CURRENT_WORKSPACE(state, { tenantId, tenantName }) {
      state.currentTenantId = tenantId;
      state.currentTenantName = tenantName;
    },
    SET_AVAILABLE_WORKSPACES(state, workspaces) {
      state.availableWorkspaces = workspaces || [];
    },
  },

  actions: {
    async loadWorkspace({ commit }) {
      try {
        const current = await workspaceService.getCurrentWorkspace(undefined);
        const available = await workspaceService.getAvailableWorkspaces(undefined);

        const currentWorkspace = available.find(
          (w) => w.tenantId === current.selectedTenantId
        );

        commit("SET_CURRENT_WORKSPACE", {
          tenantId: current.selectedTenantId,
          tenantName:
            (currentWorkspace && currentWorkspace.tenantName) ||
            current.selectedTenantId,
        });
        commit("SET_AVAILABLE_WORKSPACES", available);
      } catch (error) {
        console.error("Failed to load workspace:", error);
      }
    },
    async switchWorkspace({ dispatch }, tenantId) {
      try {
        const fromTenantId =
          this.state &&
          this.state.workspace &&
          this.state.workspace.currentTenantId != null
            ? String(this.state.workspace.currentTenantId)
            : null;
        sessionStorage.setItem(
          "assetxp_local_workspace_switch",
          JSON.stringify({
            fromTenantId,
            toTenantId: tenantId != null ? String(tenantId) : null,
            atMs: Date.now(),
          })
        );
      } catch (e) {
        // Ignore storage issues; this marker is best-effort for modal suppression.
      }

      const crossSync = await import("../services/workspaceCrossAppSync");
      if (crossSync.setWorkspaceSwitchInProgress) {
        crossSync.setWorkspaceSwitchInProgress(true);
      }
      let result;
      try {
        result = await workspaceService.switchWorkspace(tenantId, undefined);
      } finally {
        if (crossSync.setWorkspaceSwitchInProgress) {
          crossSync.setWorkspaceSwitchInProgress(false);
        }
      }
      if (result && result.cooldown && result.currentTenantId) {
        try {
          const { getUserManager } = await import(
            "../js/authentication/authentication"
          );
          const um = getUserManager();
          if (um && typeof um.signinSilent === "function") {
            await um.signinSilent();
          }
        } catch (e) {
          console.warn("[workspace] Silent renew after switch cooldown:", e);
        }
        await dispatch("authentication/updateLoggedInStatus", null, {
          root: true,
        });
      }
      if (result && result.tokenApplied) {
        await dispatch("authentication/updateLoggedInStatus", null, {
          root: true,
        });
      }
      await dispatch("loadWorkspace");
      // Refresh market list after workspace switch to ensure dropdown displays correct markets
      await dispatch("assetxpstate/GetMyMarkets", null, { root: true }).catch(
        (err) => console.warn("[workspace] Failed to refresh markets after switch:", err)
      );
    },
  },

  getters: {
    currentTenantId: (state) => state.currentTenantId,
    currentTenantName: (state) => state.currentTenantName,
    availableWorkspaces: (state) => state.availableWorkspaces,
    hasMultipleWorkspaces: (state) =>
      Array.isArray(state.availableWorkspaces) &&
      state.availableWorkspaces.length > 1,
  },
};
